'use strict';

var util = require('../../util/property-util');

module.exports = /*@ngInject*/ ["$timeout", "$q", function ($timeout, $q) {
    return {
        restrict: 'EA',
        scope: {
            query: '=',
            words: '=',
            executeQuery: '&',
            error: '='
        },
        template: [
            `
            <form>
                <div class="col-auto">
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <div class="input-group-text" style="min-width:50px">
                                <i data-cy="validQueryIcon" class="fa fa-check-circle text-success" ng-if="query && !error"></i>
                                <i data-cy="errorQueryIcon" class="fa fa-times-circle text-danger" ng-if="query && error"></i>
                            </div>
                        </div>
                        <input ng-mousedown="focusFunc()" data-cy="autoCompleteQuery" autocomplete="off" ng-keydown="key($event)" type="text" ng-model="query" ng-blur="noFocusFunc()"',
                        'ng-change="checkValidity(query)" id="autocomplete" class="form-control" caret-aware="caret" data-ng-trim="false" placeholder="{{'I18N_FILTER.ENTER_FILTER_QUERY' | translate}}">
                    </div>
                    <div ng-show="suggestions.length > 0 && !noFocus">
                    <div data-cy="autoCompleteQueryDropdown" class="list-group auto-complete-query-suggestion">
                        <div class="list-group-item list-group-item-action ng-class="{ 'active' : suggestion.active }" 
                            ng-repeat="suggestion in suggestions">
                            <div ng-mousedown="mouseDownSuggestion()" ng-click="applySuggestion(suggestion.value)">
                                <b>{{suggestion.pre}}</b>{{suggestion.post}}
                            </div>
                        </div>
                    </div>
                </div>
                </div>
            </form>

            `
        ]
            .join(''),

        link: function (scope, iElement, iAttrs, query) {
            scope.caret = 0;
            scope.suggestions = [];
            scope.noFocus = false;

            var clickDeferred;
            var activeIndex = -1;
            var externalClear = false;

            /*scope.$watch('query', function (newQuery) {
                if (query && util.isDefined(newQuery)) {
                    query.$setViewValue(newQuery);
                }
            });*/

            scope.$watch('query', function (newQuery) {
                scope.error = newQuery ? !checkValid(newQuery) : false;
            });

            scope.$watch(function () {
                return query && query.$modelValue;
            }, function (modelValue) {
                if (modelValue && modelValue != scope.query) {
                    scope.query = modelValue;
                    scope.error = scope.query && !checkValid(scope.query);
                    $timeout(function () {
                        var inputEl = angular.element(document.querySelector('#autocomplete'));
                        var caretAwareCtrl = inputEl.controller('caretAware');
                        caretAwareCtrl.setPosition(scope.query.length);
                    })
                }

                if (modelValue == "" && scope.query != "") {
                    externalClear = true;
                    scope.query = "";
                }
            });
            scope.focusFunc = function () {
                scope.noFocus = false;
                makeSuggestion(scope.query);
                externalClear = false;
            };

            scope.noFocusFunc = function () {
                if (util.isDefined(clickDeferred)) {
                    clickDeferred.promise.then(function () {
                        scope.noFocus = true;
                        clickDeferred = undefined;
                    })
                } else {
                    scope.noFocus = true;
                }
            };

            scope.key = function ($event) {
                if (!util.isDefined(scope.query)) {
                    scope.query = "";
                }

                if ($event.keyCode == 38) {
                    $event.preventDefault();
                    calculateActive(activeIndex - 1);
                }
                else if ($event.keyCode == 40) {
                    $event.preventDefault();
                    calculateActive(activeIndex + 1);
                } else if ($event.keyCode == 13 || $event.keyCode == 9) {
                    $event.preventDefault();
                    if (activeIndex != -1) {
                        scope.applySuggestion(scope.suggestions[activeIndex].value);
                        activeIndex = -1;
                    } else if (event.keyCode == 13) {
                        if (!scope.error) {
                            scope.executeQuery();
                        }

                    }
                } else {
                    activeIndex = -1;
                }
            };

            scope.mouseDownSuggestion = function () {
                clickDeferred = $q.defer();
            };

            scope.$watch('caret', function () {
                scope.noFocus = false;
                var query = scope.query;

                if (!util.isDefined(scope.query)) {
                    scope.query = "";
                }
                if (!externalClear) {
                    // makeSuggestion(query);
                }
                externalClear = false;
            });

            function calculateActive(newIndex) {
                scope.suggestions.forEach(function (suggestion) {
                    suggestion.active = false;
                });
                if (newIndex != -1) {
                    if (newIndex == -2 && scope.suggestions.length > 0) {
                        newIndex = scope.suggestions.length - 1;
                        scope.suggestions[newIndex].active = true;
                    }
                    else if (newIndex < scope.suggestions.length) {
                        scope.suggestions[newIndex].active = true;
                    } else {
                        newIndex = -1;
                    }
                }
                activeIndex = newIndex;

            }

            function makeSuggestion(query) {
                if (util.isDefined(query) && scope.caret <= query.length) {
                    var brackBegin = query.lastIndexOf("(", scope.caret - 1);
                    var spaceBegin = query.lastIndexOf(" ", scope.caret - 1);

                    var begin = brackBegin > spaceBegin ? brackBegin : spaceBegin;

                    if (begin == -1) {
                        begin = 0;
                    }

                    var word = query.substring(begin, scope.caret).trim();
                    var list = query.split(" ");


                    var usedChars = 0;
                    var i = 0;
                    for (; i < list.length; i++) {
                        if (usedChars + list[i].length >= scope.caret) {
                            break;
                        } else {
                            usedChars = usedChars + list[i].length + 1;
                        }
                    }

                    var combination = calculateCombinations(list);
                    scope.suggestions = [];

                    if (combination[i] != -1) {
                        var suggest = (combination[i]) % 4;
                        var possible;
                        switch (suggest) {
                            case 0:
                                possible = scope.words.ids;
                                break;
                            case 1:
                                possible = scope.words.mathOperators;
                                break;
                            case 2:
                                var id = list[findMatchingId(combination, i)];
                                var noBracks = id.replace(/\(/g, '');
                                noBracks = noBracks.replace(/\)/g, '');
                                possible = scope.words.valids.get(noBracks.trim().toUpperCase());
                                break;
                            case 3:
                                possible = scope.words.operators;
                                break;
                            default:

                        }

                        //if (containsValidChars(word) || word == "") {
                        var searchValue = word.replace(/\(/g, '');
                        searchValue = searchValue.replace(/\)/g, '');
                        if (util.isDefined(possible)) {
                            possible.forEach(function (value) {
                                if (value.substring(0, searchValue.length).toUpperCase() == searchValue.toUpperCase() && value.toUpperCase() != searchValue.toUpperCase()) {
                                    scope.suggestions.push({
                                        active: false,
                                        value: value,
                                        pre: searchValue.toUpperCase(),
                                        post: value.substring(searchValue.length)
                                    });
                                }
                            });
                        }
                        //}
                    }
                }
            }

            scope.applySuggestion = function (suggestion) {
                var query = scope.query;
                if (util.isDefined(query)) {
                    var brackEnd = query.indexOf(")", scope.caret);
                    var spaceEnd = query.indexOf(" ", scope.caret);
                    var brackBegin = query.lastIndexOf("(", scope.caret - 1);
                    var spaceBegin = query.lastIndexOf(" ", scope.caret - 1);
                    var begin = brackBegin > spaceBegin ? brackBegin : spaceBegin;
                    var end = -1;

                    if (brackEnd < spaceEnd && brackEnd != -1 || spaceEnd == -1) {
                        end = brackEnd;
                    } else if (spaceEnd < brackEnd && spaceEnd != -1 || brackEnd == -1) {
                        end = spaceEnd;
                    }

                    if (begin == -1) {
                        begin = 0;
                    }
                    if (end == -1) {
                        end = query.length;
                    }
                    var word = query.substring(begin, end).trim();
                    var part = query.substring(begin, scope.caret).trim();

                    var list = query.split(" ");

                    var i = 0;
                    var usedChars = 0;
                    for (; i < list.length; i++) {
                        if (usedChars + list[i].length >= scope.caret) {
                            break;
                        } else {
                            usedChars = usedChars + list[i].length + 1;
                        }
                    }

                    var combination = calculateCombinations(list);
                    var combIndex = combination[i];

                    var searchValue = word.replace(/\(/g, '');
                    searchValue = searchValue.replace(/\)/g, '');


                    var diff = suggestion.length - part.length;

                    if (containsBrackets(word)) {
                        var tmp = word.replace(/[^\(\)]/, '?');
                        var tmpIndex = tmp.indexOf('?');
                        if (tmpIndex != -1) {
                            list[i] = word.substring(0, tmpIndex) + suggestion.trim();
                        }

                        if (!containsValidChars(list[i])) {
                            list[i] = word + suggestion.trim();
                        }
                    } else {
                        list[i] = list[i].replace(searchValue.trim(), suggestion.trim());
                    }

                    for (var j = list.length - 1; j >= 0; j--) {
                        if (!containsBrackets(list[j])) {
                            if (combination[j] == combIndex && j != i && (canBeSuggestion(list[j], (combIndex % 4)) || !containsValidChars(list[j]))) {
                                list.splice(j, 1);
                            }
                        } else {
                            if (combination[j] == combIndex && j != i && containsValidChars(list[j])) {
                                var open = list[j].split("(");
                                var closed = list[j].split(")");

                                if (open.length > 1) {
                                    for (var k = open.length - 1; k >= 0; k--) {
                                        if (containsValidChars(open[k])) {
                                            open[k] = "";
                                        }
                                    }
                                    list[j] = open.join('(');
                                } else if (closed.length > 1) {
                                    for (var h = closed.length - 1; h >= 0; h--) {
                                        if (containsValidChars(closed[h])) {
                                            closed[h] = "";
                                        }
                                    }
                                    list[j] = closed.join(')');
                                }
                            }
                        }
                    }

                    scope.query = list.join(' ');
                    scope.checkValidity(scope.query);
                    scope.suggestions = [];
                    var pos = scope.caret + diff;
                    $timeout(function () {
                        var inputEl = angular.element(document.querySelector('#autocomplete'));
                        var caretAwareCtrl = inputEl.controller('caretAware');
                        caretAwareCtrl.setPosition(pos);
                    });


                }
                if (util.isDefined(clickDeferred)) {
                    clickDeferred.resolve();
                }
            };

            function findMatchingId(combination, index) {
                for (var i = index; i >= 0; i--) {
                    if (combination[i] % 4 == 0) {
                        return i;
                    }
                }
            }

            function containsBrackets(word) {
                var numOpen = (word.split("(").length - 1);
                var numClosed = (word.split(")").length - 1);

                var brackets = numOpen + numClosed;
                return brackets > 0;
            }

            function containsValidChars(word) {
                var n = word.search(/[a-zA-Z0-9><!=]/i);
                return n != -1;
            }

            function suggestionInList(list, word) {
                var searchValue = word.replace(/\(/g, '');
                searchValue = searchValue.replace(/\)/g, '');

                if (util.isDefined(list)) {
                    for (var i in list) {
                        if (list.hasOwnProperty(i)) {
                            var value = list[i];
                            if (value.substring(0, searchValue.length).toUpperCase() == searchValue.toUpperCase()) {
                                return true;
                            }
                        }
                    }
                }
                return false;
            }

            function canBeSuggestion(word, suggestIndex) {
                switch (suggestIndex) {
                    case 0:
                        return suggestionInList(scope.words.ids, word);
                    case 1:
                        return suggestionInList(scope.words.mathOperators, word);
                    case 2:
                        return suggestionInList(scope.words.values, word) || !isNaN(parseFloat(word));
                    case 3:
                        return suggestionInList(scope.words.operators, word);
                    default:
                        return false;
                }
            }

            function calculateCombinations(list) {
                var index = 0;
                var combination = [];

                for (var j = 0; j < list.length; j++) {
                    if (containsValidChars(list[j])) {
                        if (j > 0 && util.isDefined(combination[j - 1]) && containsValidChars(list[j - 1])) {
                            index++;
                        }
                    } else {
                        if (j > 0 && util.isDefined(combination[j - 1]) && containsValidChars(list[j - 1])) {
                            index++;
                        }
                    }
                    combination.push(index);
                }
                return combination;
            }

            scope.checkValidity = function (query) {
                if (query != "") {
                    scope.error = !checkValid(query);
                } else {
                    scope.error = false;
                }

            };

            var checkValid = function (query) {
                var numOpen = (query.split("(").length - 1);
                var numClosed = (query.split(")").length - 1);

                if (numOpen != numClosed) {
                    //console.log("NO matching brackets");
                    return false;
                }

                var list = query.split(" ");
                var index = 0;
                for (var i = 0; i < list.length; i++) {
                    var word = list[i].replace(/\(/g, '');
                    word = word.replace(/\)/g, '');

                    numOpen = (list[i].split("(").length - 1);
                    numClosed = (list[i].split(")").length - 1);

                    if (numOpen >= 1 && index % 4 != 3 && index % 4 != 0) {
                        //console.log("START bracket wrong id");
                        return false;
                    }
                    if ((list[i].indexOf(')') != list[i].length - 1 && numClosed >= 1 && index % 4 != 3) || (list[i] == ")" && index % 4 != 3)) {
                        //console.log("END bracket wrong id");
                        return false;
                    }
                    if (word != "") {
                        index++;
                    } else {
                        continue;
                    }

                    var suggest = (index - 1) % 4;
                    if (scope.words) {
                        switch (suggest) {
                            case 0:
                                if (scope.words.ids.indexOf(word.toUpperCase()) == -1) {
                                    //console.log("EMPTY id");
                                    return false;
                                }
                                break;
                            case 1:
                                if (scope.words.mathOperators.indexOf(word.toUpperCase()) == -1) {
                                    //console.log("EMPTY math");
                                    return false;
                                }
                                break;
                            case 2:
                                if (list[i] == "") {
                                    //console.log("EMPTY value");
                                    return false;
                                }
                                break;
                            case 3:
                                if (scope.words.operators.indexOf(word.toUpperCase()) == -1) {
                                    //console.log("AND/OR not found");
                                    return false;
                                }
                                break;
                            default:
                        }
                    }



                }
                var lastIndex = (index - 1) % 4;
                return lastIndex == 2;
            }

        }
    };
}];
